import HighlightOffIcon from '@mui/icons-material/HighlightOff'
import type React from 'react'
import { useEffect, useState } from 'react'
import { ConversationModalDelDialog } from './ConversationModalDelDialog'

type DeleteButtonProps = {
  id: string
  text: string
  onDel: (id: string) => void
}

export const DeleteButton: React.FC<DeleteButtonProps> = props => {
  const { text, id, onDel } = props
  const [open, setOpen] = useState(false)
  const [isFocused, setIsFocused] = useState(false)

  const handleOpen = () => {
    setOpen(true)
    setIsFocused(true)
  }

  const handleClose = () => {
    setOpen(false)
    setIsFocused(false)
  }

  const handleDel = () => {
    onDel(id)
    handleClose()
  }

  const handleButtonBlur = () => {
    setIsFocused(false)
  }

  const handleFocus = () => {
    setIsFocused(true)
  }

  const handleBlur = () => {
    setIsFocused(false)
  }

  const handleClick = () => {
    handleOpen()
    setIsFocused(true)
  }

  useEffect(() => {
    setIsFocused(false)
  }, [])

  return (
    <>
      {open && (
        <ConversationModalDelDialog
          open={open}
          id={id}
          text={text}
          onClose={handleClose}
          onDel={handleDel}
        />
      )}
      <HighlightOffIcon
        onBlur={handleButtonBlur}
        onClick={handleClick}
        onMouseEnter={handleFocus}
        onMouseLeave={handleBlur}
        sx={{
          color: 'red',
          mr: '32px',
          fontSize: '40px',
        }}
      />
    </>
  )
}
